export { LogoTiles as default } from './LogoTiles';